import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("同步")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消")

import { GbDialog } from '@/components/GbDialog/Index';
import { ErpAsyncForm } from '../forms/Index';

/* Hooks */
import { useErpAsyncForm } from '../hooks/useErpAsyncForm'
import { ref, unref } from 'vue';
import { GetPartType } from '../../../helpers/statusHelpers';
import { ElMessageBox } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  emits: ['finished'],
  setup(__props, { expose, emit: $emit }) {


/* Plugins */
const { register, methods, elFormRef } = useErpAsyncForm()

const showDialog = ref<boolean>(false)



/* 对外的属性与方法 */
const funcs = {

    showDialog: () => { showDialog.value = true },

    closeDialog: () => { showDialog.value = false },

    setData: (data: any) => {

        const schema = {
            original_type: GetPartType(data.part_type_id).text,
            original_no: data.no,
            original_name: data.name,
            new_type: '',
            new_type_id: '',
            new_no: '',
        }

        methods.setFormData(schema)
    }

}

const asyncAction = (data: any) => {

    /* 表单检查 */
    unref(elFormRef)?.validate((isOk: boolean) => {

        if (!isOk) return;

        methods.setLoading(true)

        /* 为什么会有这段代码？这是在营造一种：“前端我啊，在努力工作呢”的感觉，毕竟闪太快会给别人觉得有问题 */
        setTimeout(() => {

            $emit('finished', data)

            methods.setLoading(false)

            showDialog.value = false

        }, 1000);
    })
}

/* 点击同步按钮 */
const onAsyncBtnClick = () => {

    const data = methods.getFormData();

    if (data.original_no != data.no) {

        ElMessageBox.confirm('原供应商/客户编号和同步的应商/客户编号不一致，可能会出现不可预料的错误，是否继续？', '警告', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(async () => { asyncAction(data) });

    } else {

        asyncAction(data)

    }
}

expose({ funcs })


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: showDialog.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDialog).value = $event)),
    title: "同步供应商/客户资料",
    style: {"width":"640px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: _unref(methods).getLoadStatus(),
        onClick: onAsyncBtnClick
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        type: "info",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(ErpAsyncForm), { onRegister: _unref(register) }, null, 8, ["onRegister"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})